import { Component } from 'react'

// The portal had NO error boundary anywhere, so any uncaught render error took
// the whole app down — including the customer DICOM upload flow, which has
// nothing to do with whichever tab actually threw. This contains a crash to the
// subtree it happened in.
//
// Deliberately dependency-free and boring: an error boundary that can itself
// throw is worse than none. It renders plain elements, holds one piece of
// state, and reads nothing but its own props.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // No logging service in the portal; the console is what a developer has.
    console.error(`[${this.props.label || 'view'}] render failed:`, error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    const label = this.props.label || 'This view'
    return (
      <div className="border border-red-200 bg-red-50 rounded-xl px-4 py-5 text-sm">
        <p className="font-medium text-red-800">{label} could not be displayed.</p>
        <p className="text-red-700 mt-1">
          The rest of the portal is unaffected. Reload to try again — if it keeps happening, tell Deepak
          what you were looking at.
        </p>
        <div className="mt-3 flex items-center gap-3">
          <button
            onClick={() => this.setState({ error: null })}
            className="text-xs px-3 py-1.5 rounded border border-red-300 text-red-700 hover:bg-red-100"
          >
            Try again
          </button>
          <button
            onClick={() => window.location.reload()}
            className="text-xs px-3 py-1.5 rounded border border-red-300 text-red-700 hover:bg-red-100"
          >
            Reload the page
          </button>
        </div>
        <details className="mt-3">
          <summary className="text-xs text-red-600 cursor-pointer">Technical detail</summary>
          <pre className="mt-2 text-[11px] text-red-900/80 whitespace-pre-wrap break-all">
            {String(this.state.error?.message || this.state.error)}
          </pre>
        </details>
      </div>
    )
  }
}
